import React, { useEffect, useState } from 'react';

import api from "../../../../api";
import apifunctions from "../../../../api/functions.js";


const makeid = (length) => {
  let result = '';
  let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const encodeLinks = (nodes) => {
  const buildHREF = ({ Categoria_id, Rubros_ids, Lineas_ids, Marcas_ids, Grupos_ids, }) => {
    let href = '';
    if (Categoria_id) href += Categoria_id.toString();
    if (Rubros_ids.length > 0 || Lineas_ids.length > 0 || Marcas_ids.length > 0 || Grupos_ids.length > 0) {
      href += '-';
      Rubros_ids.forEach(code => {
        href += 'r' + code;
      });
      Lineas_ids.forEach(code => {
        href += 'l' + code;
      });
      Marcas_ids.forEach(code => {
        href += 'm' + code;
      });
      Grupos_ids.forEach(code => {
        href += 'g' + code;
      });
    }
    return href;
  }
  const createLink = (node) => {
    const link = {
      Nombre: node.Nombre,
      href: buildHREF(node),
      submenues: node.submenues.map(child => createLink(child)),
    }
    return link;
  }
  return nodes.map(node => createLink(node));
}

const decodeLinks = ({ links=[] }) => {
  const getInfo = (href) => {
    let Categoria_id = null;
    let Rubros_ids = [];
    let Lineas_ids = [];
    let Marcas_ids = [];
    let Grupos_ids = [];
    href = href.toString();
    href = href.replaceAll("/", "").trim();

    if (href.indexOf('-') >= 0) {
      let filtros = [];
      if (href.indexOf('-') == 0) {
        filtros = href.substring(1).match(/[\s\S]{1,5}/g);
      } else {
        Categoria_id = href.split('-')[0];
        filtros = href.split('-')[1].match(/[\s\S]{1,5}/g);
      }
      filtros.forEach(filtro => {
        if (filtro && filtro.length == 5) {
          switch (filtro.charAt(0)) {
            case 'g':
              Grupos_ids.push(filtro.substring(1));
              break;
            case 'r':
              Rubros_ids.push(filtro.substring(1));
              break;
            case 'l':
              Lineas_ids.push(filtro.substring(1));
              break;
            case 'm':
              Marcas_ids.push(filtro.substring(1));
              break;
            default:
              break;
          }
        }
      });
    } else Categoria_id = href;

    return {
      Categoria_id,
      Rubros_ids,
      Lineas_ids,
      Marcas_ids,
      Grupos_ids,
    }
  }

  const createNode = (link) => {
    const { id, href, Nombre, submenues } = link;
    const { Categoria_id, Rubros_ids, Lineas_ids, Marcas_ids, Grupos_ids, } = getInfo(href);
    const node = {
      id, Nombre,
      Categoria_id, Rubros_ids, Lineas_ids, Marcas_ids, Grupos_ids,
      submenues: submenues ? submenues.map(child => createNode(child)) : [],
    };
    return node;
  }
  return links.map(link => createNode(link));
}

const initialState = {
  links: [],
  categorias: [],
  grupos: [],
  rubros: [],
  lineas: [],
  marcas: [],
  active_item: null,
  showModal: false,
}

const useLinks = () => {
  const [state, setState] = useState({ ...initialState });

  const getData = () => {
    const successCallback = (resp) => {
      let data = undefined;
      if (resp && resp.data) {
        data = resp.data;
        data.links = decodeLinks(data);
      } else data = { ...initialState };
      setState({ ...state, ...data, });
    };
    const failureCallback = () => setState({ ...initialState });
    apifunctions.get(api.gestion.sitio.links, null, null, {}, successCallback, failureCallback, failureCallback);
  }
  useEffect(getData, [state.showModal]);
  useEffect(getData, []);

  const toggle = () => setState({ ...state, showModal: !state.showModal });

  const setActiveItem = (item) => setState({ ...state, active_item: (state.active_item != null && state.active_item.id == item.id) ? null : item });

  const updateActiveItem = (prop, value) => {
    const { active_item } = state;
    active_item[prop] = value;
    setState({ ...state, active_item });
  }

  const addNewNode = (father) => {
    const father_id = (father == null || father.id == null) ? null : father.id;

    const prevState = { ...state };

    const RecursiveIterator = (item, father_id, newNode) => {
      item.submenues = (item.id == father_id) ? [...item.submenues, newNode] : item.submenues.map(subitem => RecursiveIterator(subitem, father_id, newNode));
      return item;
    }

    const EstaId = (item, id) => {
      return item.id == id || item.submenues.filter(l => EstaId(l, id) == true).length > 0;
    };

    const links = prevState.links;
    let newId = makeid(5);
    while (links.filter(elem => EstaId(elem, newId)).length > 0) {
      newId = makeid(5);
    }

    const newNode = {
      id: newId,
      Nombre: "Nuevo Link",
      Categoria_id: null,
      Rubros_ids: [],
      Lineas_ids: [],
      Marcas_ids: [],
      Grupos_ids: [],
      submenues: [],
    };

    prevState.links = father_id ? prevState.links.map(item => RecursiveIterator(item, father_id, newNode)) : [...prevState.links, newNode];
    prevState.active_item = newNode;

    setState({ ...state, ...prevState });
  };

  const delNode = (item, fullDel) => {
    const item_id = item == null || item.id == null ? null : item.id;
    const fullDelete = fullDel == true;

    const prevState = { ...state };

    const RecursiveIterator = (elem, item_id, fullDelete) => {
      let submenues = elem.submenues;
      if (fullDelete) {
        submenues = submenues.filter(subelem => subelem.id != item_id);
      } else {
        submenues = [];
        elem.submenues.forEach((subelem) => {
          if (subelem.id != item_id) submenues.push(subelem);
          else subelem.submenues.forEach((subsubelem) => submenues.push(subsubelem));
        });
      }
      elem.submenues = submenues.map(subitem => RecursiveIterator(subitem, item_id, fullDelete));
      return elem;
    }

    if (prevState.active_item != null && prevState.active_item.id == item_id) {
      let padre = null, hermano = null, cursor = null;
      let hallado = false;
      const Preorder = (_linksArray) => {
        for (let i = 0; i < _linksArray.length; i++) {
          if (hallado == false) hermano = cursor;
          cursor = _linksArray[i];
          if (hallado == false && cursor.id == item_id) {
            hallado = true;
          }
          if (hallado == false && cursor.submenues.length > 0) {
            padre = cursor;
            Preorder(cursor.submenues);
          }
        }
      };
      Preorder(prevState.links);
      prevState.active_item = hermano ? hermano : (padre ? padre : null);
    }

    let links = [...prevState.links];
    if (fullDelete) {
      links = links.filter(elem => elem.id != item_id);
    } else {
      links = [];
      prevState.links.forEach((elem) => {
        if (elem.id != item_id) links.push(elem);
        else elem.submenues.forEach((subelem) => links.push(subelem));
      });
    }
    links = links.map(elem => RecursiveIterator(elem, item_id, fullDelete));
    prevState.links = links;

    setState({ ...state, ...prevState });
  };

  const confirm = () => {
    apifunctions.put(
      api.gestion.sitio.links,
      null,
      { links: encodeLinks(state.links) },
      () => setState({ ...initialState, showModal: false })
    );
  };

  return {
    state,
    setState,
    toggle,
    confirm,
    setActiveItem,
    addNewNode,
    delNode,
    updateActiveItem,
  }
}

export default useLinks;


// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/Links/useLinks.js